// extracted by mini-css-extract-plugin
module.exports = {"photo":"ProductDetailWrapper_photo__BXN3n","image":"ProductDetailWrapper_image__nxZs0"};